import React from 'react';
import './App.css';
import {GameBoard} from "../game/GameBoard";

function App() {
  return (
    <div className="App">
      <GameBoard></GameBoard>
    </div>
  );
}

export default App;
